import { type SxProps, type Theme } from "@mui/material";

export const successGradientBackground = (theme: Theme): string =>
  `linear-gradient(135deg, ${theme.palette.success.main} 0%, ${theme.palette.success.dark} 100%)`;

export const successGradientHoverBackground = (theme: Theme): string =>
  `linear-gradient(135deg, ${theme.palette.success.dark} 0%, ${theme.palette.success.dark} 100%)`;

export const successGradientButtonSx: SxProps<Theme> = {
  "&.Mui-disabled": {
    background: (theme) => theme.palette.action.disabledBackground,
    color: (theme) => theme.palette.action.disabled,
  },
  "&:hover": {
    background: successGradientHoverBackground,
  },
  background: successGradientBackground,
  color: "white",
};

export const successDialogTitleSx: SxProps<Theme> = {
  background: successGradientBackground,
  color: "white",
  m: 0,
  p: 2,
};

export const successSummaryBarSx: SxProps<Theme> = {
  "&:hover": {
    background: successGradientHoverBackground,
  },
  background: successGradientBackground,
  color: "white",
};

export const errorOutlinedButtonSx: SxProps<Theme> = {
  "&:hover": {
    backgroundColor: "white",
    borderColor: "error.dark",
    color: "error.dark",
  },
  backgroundColor: "white",
  borderColor: "error.main",
  color: "error.main",
};
